import { TEMPLATES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'
//
const get_template_request = () => {
  return {
    type: templatesTypes.get.request
  }
}

const get_template_success = (response) => {
  return {
    type: templatesTypes.get.success,
    payload: response.data.template
  }
}

const get_template_failure = (messages) => {
  return {
    type: templatesTypes.get.failure,
    payload: messages
  }
}

const get_template = (template_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_template_request())

    // Request
    axios.get(
      formatRoute(TEMPLATES_ROUTES.get, {id: template_id})
    ).then( response => {
      // success
      dispatch( get_template_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching template."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_template_failure(errors))
    })
  }

}

export {
  get_template
}



// WEBPACK FOOTER //
// ./src/js/actions/templates/get.js